





















































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, State } from 'vuex-class'
import { ProfileState } from '../store/profile/types'
import EventBus from '../EventBus'
import { DataState } from '../store/data/types'
import ConfirmationDialog from '../components/ConfirmationDialog.vue'

@Component({
  components: {
    ConfirmationDialog
  }
})
export default class Profile extends Vue {
  @State('profile') private profile!: ProfileState;

  @State('data') private data!: DataState;

  // eslint-disable-next-line
  @Action('updateUserData', { namespace: 'profile' }) updateUserData: any;

  // eslint-disable-next-line
  @Action('saveToFirestore', { namespace: 'profile' }) saveToFirestore: any;

  // eslint-disable-next-line
  @Action('deleteAccount', { namespace: 'profile' }) deleteAccount: any;

  deleteConfirmationDialog = false

  save () {
    this.saveToFirestore()
    EventBus.$emit('message', { level: 'info', duration: 2000, message: 'Erledigt.', subline: 'Daten wurden gespeichert!' })
    this.$gtm.trackEvent({
      event: 'profile',
      noninteraction: false
    })
  }

  get firstname () {
    return this.profile.data.firstname
  }

  set firstname (value) {
    this.updateUserData({ firstname: value })
  }

  get lastname () {
    return this.profile.data.lastname
  }

  set lastname (value) {
    this.updateUserData({ lastname: value })
  }

  get salutation () {
    return this.profile.data.salutation
  }

  set salutation (value) {
    this.updateUserData({ salutation: value })
  }

  get contactlensLeft () {
    return this.profile.data.contactlensLeft
  }

  set contactlensLeft (value) {
    this.updateUserData({ contactlensLeft: value })
  }

  get contactlensRight () {
    return this.profile.data.contactlensRight
  }

  set contactlensRight (value) {
    this.updateUserData({ contactlensRight: value })
  }

  get contactlenses () {
    return this.data.contactlenses
  }

  get allowPriceNotifications () {
    return this.profile.data.allowPriceNotifications
  }

  set allowPriceNotifications (value) {
    this.updateUserData({ allowPriceNotifications: value })
  }

  get allowOffers () {
    return this.profile.data.allowOffers
  }

  set allowOffers (value) {
    this.updateUserData({ allowOffers: value })
  }
}
